import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  showOnboardingModal: false,
  currentStep: 0,
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    setShowOnboardingModal: (state, action) => {
      state.showOnboardingModal = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    resetOnboarding: (state) => {
      state.currentStep = 0;
      state.showOnboardingModal = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const {
  setShowOnboardingModal,
  setCurrentStep,
  resetOnboarding,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
